const pos = new THREE.Vector2();
const offset = Object.seal({ left: undefined, top: undefined });

function getRelativeCoordinates(e, container = Q3.container, vec = new THREE.Vector2()) {
    let ref = container.offsetParent;

    pos.x = (!!e.touches && e.touches[0]) ? e.touches[0].pageX : e.pageX;
    pos.y = (!!e.touches && e.touches[0]) ? e.touches[0].pageY : e.pageY;

    offset.left = container.offsetLeft || 0;
    offset.top = container.offsetTop || 0;

    while (ref) {
        offset.left += ref.offsetLeft || 0;
        offset.top += ref.offsetTop || 0;

        ref = ref.offsetParent;
    }

    return vec.set(pos.x - offset.left, pos.y - offset.top);
}

export default getRelativeCoordinates;
export { getRelativeCoordinates };